"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _ramda = require("ramda");

var _date_formatter = require("../../../../packages/common-utilities/src/date_formatter.js");

var _string_utility = require("../../../../packages/common-utilities/src/string_utility.js");

var _string_utility2 = _interopRequireDefault(_string_utility);

var _reactIntl = require("react-intl");

var _functional_utility = require("../../../../packages/common-utilities/src/functional_utility");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DateDropdownComponent = function (_Component) {
  _inherits(DateDropdownComponent, _Component);

  function DateDropdownComponent() {
    _classCallCheck(this, DateDropdownComponent);

    return _possibleConstructorReturn(this, (DateDropdownComponent.__proto__ || Object.getPrototypeOf(DateDropdownComponent)).apply(this, arguments));
  }

  _createClass(DateDropdownComponent, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          _onKeyPress = _props.onKeyPress,
          label = _props.label,
          value = _props.value,
          additionalClassName = _props.additionalClassName,
          dataTest = _props.dataTest,
          dropdownContent = _props.dropdownContent,
          valueClassName = _props.valueClassName,
          fromOrToDate = _props.fromOrToDate,
          firstYear = _props.firstYear,
          lastYear = _props.lastYear,
          idSuffix = _props.idSuffix,
          shouldShowErrorState = _props.shouldShowErrorState,
          readOnly = _props.readOnly,
          resetErrorState = _props.resetErrorState,
          setRef = _props.setRef,
          _onBlur = _props.onBlur,
          setCustomFromAndToDates = _props.setCustomFromAndToDates,
          setCustomDateRangeDropdown = _props.setCustomDateRangeDropdown,
          defaultValue = _props.defaultValue;

      var verticalAlignText = {
        display: "flex",
        justifyContent: "center",
        alignContent: "center",
        flexDirection: "column",
        cursor: "pointer"
      };

      var months = function months() {
        return (0, _ramda.map)(function (month) {
          return _react2.default.createElement(
            "div",
            { className: "date-dropdown-item font-light caption background-white", role: "option", "data-testid": "dropdown-months", key: month.value, onClick: function onClick() {
                _this2.props.changeMonthYear(_string_utility2.default.getLocalizedString(_this2.props.intl, month.value, month.translationKey), "month", fromOrToDate);
                _this2.props.onHideDropdown();
              } },
            _string_utility2.default.renderFormattedLabel(month.value, month.translationKey)
          );
        }, _date_formatter.MONTHS);
      };

      var years = function years() {
        var arr = [];

        var _loop = function _loop(i) {
          arr.push(_react2.default.createElement(
            "div",
            { "data-testid": "dropdown-years", className: "date-dropdown-item font-light caption", role: "option", key: i, onClick: function onClick() {
                _this2.props.changeMonthYear(i, "year", fromOrToDate);
                _this2.props.onHideDropdown();
              } },
            i
          ));
        };

        for (var i = firstYear; i <= lastYear; i++) {
          _loop(i);
        }

        return arr;
      };

      var renderedDropdownContent = (0, _ramda.cond)([[(0, _ramda.equals)("Month"), (0, _ramda.always)(months())], [(0, _ramda.equals)("Year"), (0, _ramda.always)(years())], [_ramda.T, function () {
        return dropdownContent;
      }]]);

      var stylingForIcon = {
        bottom: "11px",
        right: "10px",
        width: "22px",
        height: "22px",
        cursor: "pointer"
      };

      var inputBorderStyling = "border-arsenic";
      if (shouldShowErrorState) {
        inputBorderStyling = "border-red";
      }
      var ariaLabel = null;
      if (!(0, _ramda.isNil)(this.props.label)) {
        ariaLabel = (0, _functional_utility.isNilOrEmpty)(this.props.label.key) ? this.props.label : _string_utility2.default.getLocalizedString(this.props.intl, this.props.label.props.defaultMessage, this.props.label.key);
      }
      return _react2.default.createElement(
        "div",
        { className: "date-dropdown " + additionalClassName, "data-testid": dataTest },
        label && _react2.default.createElement(
          "div",
          { className: "label " + (this.props.isRegularSavingsAndDesktop ? 'margin-bottom-20' : 'margin-bottom-5') + " tag-2", role: "label", id: ariaLabel },
          label
        ),
        _react2.default.createElement(
          "div",
          { className: "date-dropdown-wrapper position-relative" },
          _react2.default.createElement("input", {
            ref: (0, _ramda.isNil)(setRef) ? function (input) {
              _this2["dropdown-toggle-" + idSuffix] = input;
            } : setRef,
            type: "text",
            id: "dropdown-toggle-" + idSuffix,
            className: "padding-horizontal-10 " + (0, _functional_utility.ifMobileBreakpoint)(this.props.breakpoint, "body2", "disclaimer") + " height-38 border-all-1 border-radius-4 " + inputBorderStyling,
            style: verticalAlignText,
            "aria-labelledby": ariaLabel,
            defaultValue: !(0, _ramda.isNil)(defaultValue) ? _string_utility2.default.getLocalizedString(this.props.intl, defaultValue, 'month-' + defaultValue) : _string_utility2.default.getLocalizedString(this.props.intl, value, "date-dropdown-" + value.toLowerCase()),
            readOnly: readOnly,
            onClick: function onClick() {
              if (typeof setCustomDateRangeDropdown === 'function') {
                setCustomDateRangeDropdown();
              }
            },
            onKeyPress: function onKeyPress(e) {
              _onKeyPress(e, _this2["dropdown-toggle-" + idSuffix]);
            },
            onBlur: function onBlur(e) {
              if (typeof _onBlur === 'function') {
                _onBlur(e, _this2["dropdown-toggle-" + idSuffix]);
              }
            },
            "data-testid": "input-" + idSuffix
          }),
          !shouldShowErrorState && _react2.default.createElement("span", { "data-testid": "calendar-" + idSuffix, className: valueClassName + " disclaimer position-absolute",
            id: "date-dropdown-toggle",
            style: stylingForIcon,
            onClick: function onClick(e) {
              if (_this2.props.openDropdown) {
                _this2.props.onHideDropdown();
                if (typeof setCustomFromAndToDates === 'function') {
                  setCustomFromAndToDates(e, fromOrToDate === "from" ? "from-dropdown" : "to-dropdown");
                }
              } else {
                _this2.props.onShowDropdown();
              }
              if (typeof setCustomDateRangeDropdown === 'function') {
                setCustomDateRangeDropdown();
              }
            } }),
          shouldShowErrorState && _react2.default.createElement("span", { "data-testid": "error-close-" + idSuffix, className: "icon-close font-red disclaimer position-absolute",
            style: stylingForIcon,
            onClick: resetErrorState
          })
        ),
        !shouldShowErrorState && _react2.default.createElement(
          "div",
          { className: "dropdown-wrapper " + (this.props.openDropdown ? "show" : "hide") },
          _react2.default.createElement(
            "div",
            { className: "dropdown", role: "listbox" },
            renderedDropdownContent(value)
          )
        )
      );
    }
  }, {
    key: "updateValue",
    value: function updateValue(key, value) {
      if (!(0, _ramda.isNil)(this[key])) {
        this[key].value = value;
      }
    }
  }]);

  return DateDropdownComponent;
}(_react.Component);

exports.default = (0, _reactIntl.injectIntl)(DateDropdownComponent, { withRef: true });